// Tenantra Inc. - Public demo page. Shareable link for prospects to watch the application demo video.
import { useState } from 'react';
import { motion } from 'framer-motion';
import { PlayCircle, ShieldCheck } from 'lucide-react';
import { Logo } from '@/components/Logo';

const VIDEO_URL = 'https://customer-assets-eiarnc6j.emergentagent.net/job_ec94d316-ae4f-4e18-badd-769523b42480/artifacts/a8b0635db1dcdfc5_Tenantra_%20Stop%20Checking%20by%20Hand%20v2.mp4';

export default function DemoPage() {
  const [playing, setPlaying] = useState(false);
  return (
    <div className="apply-type min-h-screen bg-white">
      <header className="bg-white/90 backdrop-blur border-b border-stone-200 sticky top-0 z-20">
        <div className="max-w-4xl mx-auto px-5 h-14 flex items-center"><Logo /></div>
      </header>

      <main className="max-w-4xl mx-auto px-5 py-12 sm:py-16">
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
          <p className="inline-flex items-center gap-1.5 text-[13px] font-medium text-teal-700 bg-teal-50 border border-teal-100 rounded-full px-3 py-1" data-testid="demo-eyebrow">
            <ShieldCheck className="w-3.5 h-3.5" /> Tenant screening, automated
          </p>
          <h1 className="mt-4 text-[2rem] sm:text-[2.5rem] font-bold tracking-tight text-stone-900 leading-[1.1]" data-testid="demo-title">
            Watch the application demo video
          </h1>
          <p className="mt-3 text-base sm:text-lg text-stone-700 max-w-2xl leading-relaxed" data-testid="demo-subtitle">
            See how Tenantra reads applicant documents, verifies income, flags fraud, and produces a single Fit Score, so you stop checking applications by hand.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45, delay: 0.1 }}
          className="mt-8 rounded-[1.75rem] bg-stone-900 border border-stone-700/70 p-2.5 sm:p-3 shadow-2xl shadow-black/40"
          data-testid="demo-video-wrap"
        >
          <div className="relative rounded-[1.25rem] overflow-hidden bg-black">
            {playing ? (
              <video
                src={VIDEO_URL}
                controls
                autoPlay
                playsInline
                className="w-full aspect-video bg-black"
                data-testid="demo-video"
              />
            ) : (
              <button
                type="button"
                onClick={() => setPlaying(true)}
                className="group w-full aspect-video flex flex-col items-center justify-center gap-3 bg-gradient-to-br from-stone-900 to-stone-800 text-white"
                data-testid="demo-play-button"
              >
                <PlayCircle className="w-16 h-16 text-white/90 group-hover:scale-110 transition-transform" />
                <span className="text-base font-semibold tracking-tight">Watch application demo video</span>
                <span className="text-[13px] text-white/60">2 min · no sign-up needed</span>
              </button>
            )}
          </div>
        </motion.div>

        <p className="mt-6 text-[13px] text-stone-500" data-testid="demo-footnote">
          Tenantra Inc. · Secure, automated rental screening for landlords and property managers.
        </p>
      </main>
    </div>
  );
}
